export default "__VITE_PUBLIC_ASSET__cb79a06a__"